import whiteArrow from './assets/white-arrow.svg';
import blueArrow from './assets/blue-arrow.svg'
import doctors from './assets/doctors.png';
import room from './assets/room.png'
import head from './assets/head.svg'
import doctorsMobile from './assets/doctors-mobile.png'

const Apoio = () => {
    return ( 
        <div className="apoio" id='apoio'>
            <div className="first-column">
                <div className="auto-card">
                    <h2>Realize uma autoavaliação gratuita</h2>
                    <span>Confira os níveis da sua compulsividade e as formas que podemos te ajudar.</span>
                    <a href="/autoavaliacao"> <div className="arrow"><img src={blueArrow} alt="" /></div></a>
                </div>
                <div className="help-card">
                    <img src={doctors} alt="" className='doctors-image'/>
                    <img src={doctorsMobile} alt="" className="doctors-mobile" />
                    <div className="help-texts">
                        <h2>Precisa de ajuda imediata?</h2>
                        <span>Converse agora com a nossa equipe via Whatsapp.</span>
                    </div>
                    <a href="https://api.whatsapp.com/send?phone=558006761000&text=Olá! Sou cliente de uma empresa parceira e gostaria de ajuda." target='_blank' rel='noreferrer'> <div className="arrow"><img src={whiteArrow} alt="" /></div></a>
                </div>
            </div>
            <div className="second-column">
                <div className="room-card">
                    <img src={room} alt="" />
                    <div className="room-texts">
                        <h2>Salas de apoio</h2>
                        <p>Um espaco dedicado ao seu bem-estar, com recursos e suporte para que o jogo permaneça uma experiência saudável.</p>
                    </div>
                    <a href="/salas"> <div className="arrow"><img src={whiteArrow} alt="" /></div></a>
                </div>
                <div className="appoint-card">
                    <h2>Agende sua consulta agora mesmo</h2>
                    <span>Sentindo que as apostas estão fugindo do controle? Fale conosco!</span>
                    <a href="https://api.whatsapp.com/send?phone=558006761000&text=Olá! Gostaria de agendar uma consulta." target='_blank' rel='noreferrer'> <div className="arrow"><img src={blueArrow} alt="" /></div></a>
                    <img className='head' src={head} alt="" />
                </div>
            </div>
        </div>
     );
}
 
export default Apoio;